import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";

export default class extends Controller {
  static targets = ["searchInput"];

  update_list() {
    console.log("Updating list based on search input:", this.searchInputTarget.value);
    console.log(this.searchInputTarget);
  }

  removeItem(event) {
    event.preventDefault();
    this.postTurboStream(event.currentTarget.dataset.removeUrl);
  }

  postTurboStream(url) {
    const csrfToken = document.querySelector("meta[name='csrf-token']").content;

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html",
      }
    })
    .then((response) => response.text())
    .then(html => {
      Turbo.renderStreamMessage(html);
    })
    .catch(error => {
      console.error("Error removing item:", error);
    });
  }
}
